var map = {
	"./Lottie-anywhere.json": [
		41423,
		7428
	],
	"./Lottie-benefit.json": [
		20442,
		442
	],
	"./Lottie-calculations.json": [
		37427,
		7427
	],
	"./Lottie-coffe.json": [
		52962,
		2962
	],
	"./Lottie-community.json": [
		4174,
		4174
	],
	"./Lottie-education.json": [
		41450,
		1450
	],
	"./Lottie-finance.json": [
		55855,
		5855
	],
	"./Lottie-gift-card.json": [
		7794,
		7794
	],
	"./Lottie-holding.json": [
		39771,
		9771
	],
	"./Lottie-marketing.json": [
		54415,
		4415
	],
	"./Lottie-payment-declined.json": [
		76712,
		6712
	],
	"./Lottie-payment-received.json": [
		7598,
		7598
	],
	"./Lottie-shopping-bag-add.json": [
		85404,
		5404
	],
	"./Lottie-shopping-bag-checkout.json": [
		50087,
		87
	],
	"./Lottie-shopping-bag-empty.json": [
		58617,
		8617
	],
	"./Lottie-shopping-bag-remove.json": [
		10028,
		28
	],
	"./Lottie-task-list.json": [
		21271,
		1271
	],
	"./Lottie-video-thumbnail.json": [
		74224,
		4224
	],
	"./Lottie-vip.json": [
		99734,
		9734
	],
	"./Lottie-wallet.json": [
		38545,
		8545
	],
	"./Lottie-yoga-2.json": [
		25464,
		5464
	],
	"./Lottie-yoga.json": [
		7383,
		7383
	],
	"./shopping-bag-3099007.json": [
		79549,
		9549
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 80729;
module.exports = webpackAsyncContext;